import { LOCALE_ID, Pipe, PipeTransform, inject } from '@angular/core';

import { Store } from '@app/shared/modules/mobile-badge/enums/store.enum';
import { STORES } from '@app/shared/modules/mobile-badge/constants/stores.constant';

@Pipe({
  name: 'badgeUrl',
  standalone: false,
})
export class BadgeUrlPipe implements PipeTransform {
  private localeId = inject(LOCALE_ID);

  readonly badgesDir = 'assets/img/badges';
  readonly stores = STORES;

  transform(store: Store): string {
    const isGlobal = !this.localeId?.includes('ru');
    return `${this.badgesDir}/${
      this.stores[store][isGlobal ? 'global' : 'ru']
    }`;
  }
}
